import { Route } from '@angular/router';
import {DomainGuard} from './guards/domain.guard';
import {CommonGuard} from './guards/common.guard';

export const APP_ROUTES: Route[] = [
  {
    path: '',
    redirectTo: 'common',
    pathMatch: 'full'
  },
  {
    canActivate: [CommonGuard],
    path: 'common', loadChildren: () => import('./common/feature-shell/common.routes').then((r) => r.CommonRoutes)
  },
  {
    canActivate: [DomainGuard],
    path: '', loadChildren: () => import('./core/core.routes').then((r) => r.CoreRoutes)
  }
];

